import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';

const GlobalContext = createContext();
export const useGlobalContext = () => useContext(GlobalContext);

export const GlobalProvider = ({ children }) => {
  const [periode, setPeriode] = useState('');
  const [periodeakun, setPeriodeAkun] = useState('');
  const [nama, setNama] = useState('');
  const [kode, setUser] = useState('');
  const [koderole, setKodeRole] = useState('');
  const [menuakses, setMenuakses] = useState([]);
  const [isReady, setIsReady] = useState(false);    
  const baseURL = process.env.REACT_APP_BASE_URL;

  const api = useMemo(() => { 
    return axios.create({
      baseURL: baseURL,
      withCredentials: true,
      timeout: 10000,
    });
  },[baseURL]);

  console.log("Base URL dari GlobalContext:", baseURL);

  const clearUserData = useCallback(() => {
    localStorage.removeItem("pengguna");
    setKodeRole('');
    setNama('');
    setPeriode('');
    setIsReady(false);
    delete axios.defaults.headers.common['Authorization'];
    delete api.defaults.headers.common['Authorization'];
  },[api]);

  const bulan = [
    "Januari", "Februari", "Maret", "April", "Mei", "Juni",
    "Juli", "Agustus", "September", "Oktober", "November", "Desember"
  ];

  const loadUserData = useCallback(async () => {
    const stored = localStorage.getItem("pengguna");   

    if (!stored) {
      clearUserData();
      return;
    }

    try {
      const parsed = JSON.parse(stored);

      setUser(parsed.kode || '');
      setNama(parsed.pengguna || '');
      setKodeRole(parsed.kode_role || '');

      console.log("Data pengguna dimuat:", parsed);

     
      const res = await api.get('/api/setup/periode');
      setPeriode(String(res.data) || '');

      const resAkun = await api.get('/api/akuntansi/periode');
      setPeriodeAkun(String(resAkun.data) || '');

      console.log("Periode dimuat:", res.data);
      console.log("Periode Akun dimuat:", resAkun.data);

      setIsReady(true);
    } catch (error) {
      console.error("❌ Data pengguna rusak atau tidak valid:", error);
      clearUserData();
    }
  },[api, clearUserData]);

  const loadAksesMenu = useCallback( async () => {
    if (!koderole) {
      setMenuakses([]);
      return;
    }
    try {
      const response = await api.get(`/api/menu/aksesuser/${koderole}`);
      if (response && response.data) {
        setMenuakses(response.data); // simpan data ke state
      } else {
        setMenuakses([]);
      }
    } catch (error) {
      console.error("Gagal mengambil menu akses:", error);
      setMenuakses([]);
    }
  },[api, koderole]);

  useEffect(() => {
    loadUserData();
    //loadAksesMenu();
  },[loadUserData]);
  //,loadAksesMenu]);

  useEffect(() => {    
    loadAksesMenu();
  },[loadAksesMenu]);


  return (
    <GlobalContext.Provider
      value={{
        periode, periodeakun, setPeriode, koderole, kode, nama, setNama, bulan, loadUserData, api, isReady, clearUserData, baseURL, menuakses, setMenuakses
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
